// extracted by mini-css-extract-plugin
export var cardContainer = "_no-0";
export var cardHeader = "_no-2";
export var collapsedState = "_no-3";
export var dragHandle = "_no-5";
export var dragHandleIcon = "_no-6";
export var dragging = "_no-1";
export var titleArea = "_no-4";